module.exports = __webpack_public_path__ + "img/statue-of-liberty.4eac4aa0.png";